
import API from "@utilities/smart_api";
import { SmartAPIClass } from "@utilities/smart_api_class";
import { DandDAPIClass } from "@dndUtilities/system_api_class";

const DandDAPI = (function() {
  let api: SmartAPIClass;

  return {
    getInstance: function() {
      if (!api) {
        api = API.getInstance();
      }
      if (!api.apis.dandd) {
        api.apis.dandd = new DandDAPIClass();
      }
      return api.apis.dandd as DandDAPIClass;
    }
  };
})();


export default DandDAPI;
